/* eslint-disable camelcase */
import React, {
    useContext,
    useEffect,
    useState
} from 'react'
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { useTranslator } from '@jutro/locale';
import { LocalDateUtil } from '@xengage/gw-portals-util-js';
import { ViewModelServiceContext, withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { MLAlertGroupComponent } from 'ml-components-common-react';
import { MLBundleService } from 'ml-services-common-react';
import { MLModalService } from 'ml-portals-services-react';
import { MLQuoteNameUtil, MLLineTypeUtil } from 'ml-portals-util-js';
import { MLNotificationBlockUtil } from 'ml-portals-util-react';
import { MLTagManagerService } from 'ml-portals-services-react'

import metadata from './MLBundleConfirmation.metadata.json5';
import messages from './MLBundleConfirmation.messages';
import styles from './MLBundleConfirmation.module.scss';

import { TooltipIcon  } from '@jutro/components';

import { IntlContext } from '@jutro/legacy/locale';

function MLBundleConfirmation(props){
    const intl = useContext(IntlContext);
    const translator = useTranslator();
    const viewModelService = useContext(ViewModelServiceContext);
    const { authHeader } = useAuthentication();

    const {
        history,
        match
    } = props;

    const {
        params: { accountNumber }
    } = match;


    const {
        showProgressDialog
    } = MLModalService();
    const {
        addSuccessAlert,
        clearAlerts
    } = MLNotificationBlockUtil();

    const [policySummaries, updatePolicySummaries] = useState([]);
    const [policyDetails, updatePolicyDetails] = useState([]);
    const ratingPaymentMethodTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('RatingPaymentMethod_ML');

    const isAutoPolicy = (policyDetail) => {
        return policyDetail.lines.some((line) => MLLineTypeUtil.isPersonalAuto(line));
    };

    const isHomePolicy = (policyDetail) => {
        return policyDetail.lines.some((line) => MLLineTypeUtil.isHomeOwners(line));
    };

    const isUmbrellaPolicy = (policyDetail) => {
        return policyDetail.lines.some((line) => MLLineTypeUtil.isPersonalUmbrella(line));
    };

    const _getRatingPaymentMethod = (paymentDetails) => {
        const paymentMethod = ratingPaymentMethodTypelist.getCode(paymentDetails.ratingPaymentMethod_ML);
        const translatedPaymentMethod = translator({id: paymentMethod.name, defaultMessage: paymentMethod.name})
        let endingNumbers = '';
        if (paymentDetails.last4Digits) {
            endingNumbers = ` - ${translator(messages.endingIn, {cardNumber: paymentDetails.last4Digits})}`;
        }
        return translatedPaymentMethod + endingNumbers;
    };

    const _getDownPaymentMethod = (paymentDetails) => {
        const paymentMethod = paymentDetails.downPaymentMethod;
        let endingNumbers = '';
        if (paymentDetails.downPaymentLast4Digits) {
            endingNumbers = ` - ${translator(messages.endingIn, {cardNumber: paymentDetails.downPaymentLast4Digits})}`;
        }
        return paymentMethod + endingNumbers;
    };

    const _getProductName = (policyDetail) => {
        let productName = '';
        if (isHomePolicy(policyDetail)) {
            productName = MLQuoteNameUtil.getCoveragePartTypeName(policyDetail.coveragePartType);
        } else if (isAutoPolicy(policyDetail)) {
            productName = translator(messages.auto);
        } else if (isUmbrellaPolicy(policyDetail)) {
            productName = translator(messages.umbrella);
        }

        return productName;
    };

    const _initPolicySummaries = (policies) => {
        updatePolicySummaries(policies.map((policyDetail) => {
            return {
                periodStartDate: policyDetail.effective_ML,
                periodEndDate: policyDetail.expiration_ML,
                policyNumber: policyDetail.policyId,
                openContingencies: policyDetail.openContingencies,
                paymentDetails: policyDetail.paymentDetails,
                paymentDate: policyDetail.paymentDetails.paymentReceivedLocalDate,
                selectedPaymentMethod: _getRatingPaymentMethod(policyDetail.paymentDetails),
                selectedDownPaymentMethod: _getDownPaymentMethod(policyDetail.paymentDetails),
                accountHolder: policyDetail.policyHolder,
                dob: policyDetail.policyHolder.dateOfBirth,
                coinsured: policyDetail.secondaryInsured_ML,
                policyAddress: policyDetail.policyAddress,
                productName: _getProductName(policyDetail),
                paData: isAutoPolicy(policyDetail) ? policyDetail.lobs.personalAuto.coverables.vehicles : policyDetail.vehicles_ML,
                isAuto: isAutoPolicy(policyDetail),
                isHome: isHomePolicy(policyDetail),
                isUmbrella: isUmbrellaPolicy(policyDetail),
                mailingAddress: policyDetail.mailingAddress
            };
        }));
    };

    const _bundleConfirmationMessage = () => {
        clearAlerts();
        addSuccessAlert(messages.congratulationAlertText, 'bundlePolicyIssuanceMsg');
    };

    const _retrieveIssuedBundleSubmission = () => {
        const policyPromise = MLBundleService.getIssuedBundlePolicies(accountNumber, authHeader);
        
        showProgressDialog(messages.retrievingPolicies, policyPromise);

        policyPromise.then((policies) => {
            // filter out withdrawn/declined bundled submission that doesn't have policyId
            const filteredPolicies = policies.filter((policy) => policy.policyId);
            updatePolicyDetails(filteredPolicies);
            _initPolicySummaries(filteredPolicies);
            _bundleConfirmationMessage();
        });
    };

    const _triggerPurchaseEvent = () => {
        if (policySummaries) {
            let productAmount = '';
            let productMethod = '';
            let confirmationID = '';
            let policyNumber = '';
            policySummaries.forEach((policy, index) => {
                productAmount += policy.paymentDetails.amountCharged.amount;
                productMethod += ratingPaymentMethodTypelist.getCode(policy.paymentDetails.ratingPaymentMethod_ML).name;
                confirmationID += policy.paymentDetails.confirmationNumber;
                policyNumber += policy.policyNumber;
                if (index !== policySummaries.length - 1) {
                    productAmount += '|';
                    productMethod += '|';
                    confirmationID += '|';
                    policyNumber += '|';
                }
            });

            // eslint-disable-next-line no-unused-vars
            const attributes = {
                productAmount: productAmount,
                productMethod: productMethod,
                confirmationID: confirmationID,
                policyNumber: policyNumber
            };
            MLTagManagerService.sendBundleEvent('purchasePolicy', attributes);
        }

    };
    
    useEffect(() => {
        _retrieveIssuedBundleSubmission();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if(policySummaries.length > 0){
            _triggerPurchaseEvent();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [policySummaries]);

    const getContingencies = () => {
        const contingencies = [];

        policyDetails?.forEach((policyDetail) => {
            const contigenciesDetails = policyDetail?.openOrClosedContingencies

            if (contigenciesDetails) {
                const contigenciesWithPolicyNumber = contigenciesDetails.map((con) => ({
                    ...con,
                    policyNumber: policyDetail.policyId
                }))

                contingencies.push(...contigenciesWithPolicyNumber);
            }
        });

        return contingencies;
    };

    const printQuote = ()=> {
        MLTagManagerService.sendBundleEvent('linkClick', {linkName: 'printConfirmation'});
        window.print();
    };


    const goToAccount = () => {
        MLTagManagerService.sendBundleEvent('linkClick', {linkName: 'GoToAccount'});
        history.push(`/accounts/${accountNumber}/summary`)
    };

    const isMortgageePayFirstYear = (paymentDetails) => {
        return !!(paymentDetails.isPayThroughMortgage && paymentDetails.firstYear);
    };

    const _getSuffixName = (suffixCode) => {
        const suffixName = viewModelService.productMetadata.get('pc').types.getTypelist('NameSuffix').getCode(suffixCode).name;
        return translator({
            id: suffixName,
            defaultMessage: suffixName
        })
    };

    const getFullName = (policyHolder) => {
        if(!policyHolder){
            return '';
        }
        const middleName = policyHolder.middleName || '';
        const suffix = policyHolder.suffix ? _getSuffixName(policyHolder.suffix) : '';
        return `${policyHolder.name} ${middleName} ${policyHolder.lastName} ${suffix}`;
    };
        
    const getFormattedDateString = (gwDateVal) => {
        const date = LocalDateUtil.toMidnightDate(gwDateVal);
        return intl.formatDate(date, { year: 'numeric', month: '2-digit', day: '2-digit' });
    };

    const getFormatCurrency = (value) => {
        let formattedAmount = '';
        if (value) {
            const { amount, currency } = value;
            if (!_.isUndefined(amount) && currency) {
                formattedAmount = intl.formatNumber(
                    amount,
                    {
                        style: 'currency',
                        currency: currency
                    }
                );
            }
        }
        return formattedAmount;
    };

    const getPolicyVehiclesContent = (policy) => {
        if(!policy.isAuto){
            return '';
        }
        return(
            <React.Fragment>
                {policy.paData && policy.paData.map((vehicle) => {
                    return(
                        <div>
                            {!!vehicle.namedNonOwner_ML && 
                                <span>{translator(messages.namedNonOwner)}</span>
                            }
                            {!vehicle.namedNonOwner_ML && 
                                <span>{vehicle.displayName}</span>
                            }
                        </div>
                    )
                })}
            </React.Fragment>
        )

    }

    const getContingenciesTableData = () => {
        const openOrClosedContingencies = getContingencies();
        const contingenciesData = [
            {
                title: "Watch your email inbox for more information.",
                docRetentionStatus: "Information",
                policyNumber: "NA"
            },
            {
                title: "Remember to notify your current carrier of your new policy with us so they can cancel your policy on the effective date listed above.",
                docRetentionStatus: "Information",
                policyNumber: "NA"
            },
            ...openOrClosedContingencies
        ]

        return contingenciesData

    }

    const generatePoliciesOverrideProps = () => {
        const overrides = policySummaries.map((policy, index) => {
            return {
                [`mlConfirmationPageVehiclesSection${index}`]: {
                    visible: policy.isAuto
                },
                [`mlConfirmationPagePropertyAddressSection${index}`]: {
                    visible: policy.isHome
                },
                [`mlConfirmationPageUmbrellaPlaceholder${index}`]: {
                    visible: policy.isUmbrella
                },
                [`mlConfirmationPagePolicyDetailSectionAutoContainer${index}`]: {
                    visible: policy.isAuto
                },
                [`mlConfirmationPagePolicyDetailSectionHomeContainer${index}`]: {
                    visible: policy.isHome
                },
                [`mlConfirmationPagePolicyDetailSectionUmbrellaContainer${index}`]: {
                    visible: policy.isUmbrella
                },
                [`mlConfirmationPagePolicyDetailSectionAutoProductName${index}`]: {
                    content: translator(messages.productNamePolicy, {productName: policy.productName})
                },
                [`mlConfirmationPagePolicyDetailSectionAutoPolicyNumber${index}`]: {
                    content: policy.policyNumber
                },
                [`mlConfirmationPagePolicyDetailSectionHomeProductName${index}`]: {
                    content: translator(messages.productNamePolicy, {productName: policy.productName})
                },
                [`mlConfirmationPagePolicyDetailSectionHomePolicyNumber${index}`]: {
                    content: policy.policyNumber
                },
                [`mlConfirmationPagePolicyDetailSectionUmbrellaProductName${index}`]: {
                    content: translator(messages.productNamePolicy, {productName: policy.productName})
                },
                [`mlConfirmationPagePolicyDetailSectionUmbrellaPolicyNumber${index}`]: {
                    content: policy.policyNumber
                },
                [`mlConfirmationPagePolicyDetailSectionEffDateValue${index}`]: {
                    content: getFormattedDateString(policy.periodStartDate)
                },
                [`mlConfirmationPagePolicyDetailSectionExpDateValue${index}`]: {
                    content: getFormattedDateString(policy.periodEndDate)
                },
                [`mlConfirmationPagePaymentMethodValue${index}`]: {
                    content: `${policy.selectedPaymentMethod} `
                },
                [`mlConfirmationPagePaymentDownPaymentContainer${index}`]: {
                    visible: !isMortgageePayFirstYear(policy.paymentDetails) && policy.paymentDetails.amountCharged.amount > 0
                },
                [`mlConfirmationPageDownPaymentAmount${index}`]: {
                    visible: !isMortgageePayFirstYear(policy.paymentDetails)
                },
                [`mlConfirmationPagePaymentAmountValue${index}`]: {
                    content: getFormatCurrency(policy.paymentDetails.amountCharged)
                },
                [`mlConfirmationPageDownPaymentDate${index}`]: {
                    visible: !isMortgageePayFirstYear(policy.paymentDetails)
                },
                [`mlConfirmationPageDownPaymentDateValue${index}`]: {
                    content: getFormattedDateString(policy.paymentDate)
                },
                [`mlConfirmationPageConfirmationNumber${index}`]: {
                    visible: !!policy.paymentDetails.confirmationNumber
                },
                [`mlConfirmationPageConfirmationNumberValue${index}`]: {
                    content: policy.paymentDetails.confirmationNumber
                },
                [`mlConfirmationPageDownPaymentMethodValue${index}`]: {
                    content: policy.selectedDownPaymentMethod
                },
                [`mlConfirmationPageInsuredAccountHolder${index}`]: {
                    content: _.startCase(_.lowerCase(getFullName(policy.accountHolder)))
                },
                [`mlConfirmationPageInsuredAddressLine1${index}`]: {
                    content: policy.mailingAddress.addressLine1
                },
                [`mlConfirmationPageInsuredAddressLine2${index}`]: {
                    visible: !!policy.mailingAddress.addressLine2,
                    content: policy.mailingAddress.addressLine2
                },
                [`mlConfirmationPageInsuredAddressLine3${index}`]: {
                    content:`${policy.mailingAddress.city}, ${policy.mailingAddress.state} ${policy.mailingAddress.postalCode}`
                },
                [`mlConfirmationPageCoInsuredSection${index}`]: {
                    visible: !!policy.coinsured
                },
                [`mlConfirmationPageCoInsuredAccountHolder${index}`]: {
                    content: _.startCase(_.lowerCase(getFullName(policy.coinsured)))
                },
                [`mlConfirmationPageVehiclesList${index}`]: {
                    content: getPolicyVehiclesContent(policy)
                },
                [`mlConfirmationPagePropertyAddressLine1${index}`]: {
                    content: _.get(policy, 'policyAddress.addressLine1')
                },
                [`mlConfirmationPagePropertyAddressLine2${index}`]: {
                    visible: !!_.get(policy, 'policyAddress.addressLine2'),
                    content: _.get(policy, 'policyAddress.addressLine2')
                },
                [`mlConfirmationPagePropertyAddressLine3${index}`]: {
                    content:`${_.get(policy, 'policyAddress.city')}, ${_.get(policy, 'policyAddress.state')} ${_.get(policy, 'policyAddress.postalCode')}`
                },
                
                
            };
        });

        
        return Object.assign({}, ...overrides);
    }

    const generateContingenciesOverrides = () =>{
        const overrides = getContingenciesTableData().map((openContingency, index) => ({
                [`contingencyTitle${index}`]: {
                    content: (<div>
                        <li>{openContingency.title} &nbsp;
                        {openContingency.description_ML && <TooltipIcon
                            text={openContingency.description_ML}
                            />}
                        </li>
                    </div>)
                },
                [`contingencyAction${index}`]: {
                    content: (<div>
                        <li>{openContingency?.docRetentionStatus}
                        </li>
                    </div>)
                },
                [`contingencyPolicyNumber${index}`]: {
                    content: (<div>
                        <li>{openContingency?.policyNumber}
                        </li>
                    </div>)
                }              
            }));

        
        return Object.assign({}, ...overrides);
    }

    const overrideProps = {
        mlConfirmationPagePoliciesFragment: {
            data: policySummaries
        },
        openContingenciesIterable: {
            data:  getContingenciesTableData()
        },

        ...generatePoliciesOverrideProps(),
        ...generateContingenciesOverrides()
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            printQuote,
            goToAccount
        },
        resolveComponentMap: {
            MLAlertGroupComponent
        }
    };

    return (
        <MetadataContent
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            {...resolvers} />
    );
}

export default withRouter(withViewModelService(MLBundleConfirmation));